import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RentaComponent} from './renta/renta.component';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatSliderModule} from '@angular/material/slider';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {ShareComponent} from './share/share.component';
import {ConfirmComponent} from './confirm/confirm.component';
import {DemoAccountComponent} from './demo-account/demo-account.component';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {ShareIconsModule} from 'ngx-sharebuttons/icons';
import {ShareButtonsConfig, SharerMethod} from 'ngx-sharebuttons';
import {MessagesModule} from '@components/messages/messages.module';
import {LoginComponent} from './login/login.component';
import {PipeModule} from '~/app/shared/pipe/pipe.module';
import {PartnerComponent} from './partner/partner.component';
import {PubComponent} from './pub/pub.component';
import {InvestPreneurComponent} from './invest-preneur/invest-preneur.component';
import {DpeComponent} from './dpe/dpe.component';
import {GesComponent} from './ges/ges.component';
import {TutoComponent} from './tuto/tuto.component';
import {AccountComponent} from './account/account.component';
import {FormComponent} from './form/form.component';
import {NewsComponent} from './news/news.component';
import {RateComponent} from './rate/rate.component';
import {CalendlyComponent} from './calendly/calendly.component';
import {LeducationFinanciereComponent} from './leducation-financiere/leducation-financiere.component';
import {PolygoneComponent} from './polygone/polygone.component';
import {LoginFormComponent} from './login-form/login-form.component';
import {AlertModule} from '@components/alert/alert.module';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {UserRoutes} from '@module/users/users.module';
import {UpgradePlanV2Component} from './upgrade-plan-v2/upgrade-plan-v2.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ToomanyFavComponent} from './toomany-fav/toomany-fav.component';
import {PurpleComponent} from './purple/purple.component';
import {IncreaseTrialComponent} from './increase-trial/increase-trial.component';
import {StarRatingModule} from 'angular-star-rating';
import {ShowPromoComponent} from './show-promo/show-promo.component';
import {EditCaracComponent} from './edit-carac/edit-carac.component';
import {EditAnnexeComponent} from './edit-annexe/edit-annexe.component';
import {EditOtherCaracComponent} from './edit-other-carac/edit-other-carac.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DirectiveModule} from '~/app/shared/directives/directive.module';
import {EditDiagComponent} from './edit-diag/edit-diag.component';
import {EditDescriptionComponent} from './edit-description/edit-description.component';
import {PhoneComponent} from './phone/phone.component';
import { VideoComponent } from './video/video.component';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import { QlowerComponent } from './qlower/qlower.component';
import { EndtrialComponent } from './endtrial/endtrial.component';
import { ConfirEndtrialComponent } from './confir-endtrial/confir-endtrial.component';
import { ChurnComponent } from './churn/churn.component';

const customConfig: ShareButtonsConfig = {
    include: ['facebook', 'twitter', 'whatsapp', 'linkedin', 'email', 'copy'],
    theme: 'material-dark',
    twitterAccount: '@lybox1',
    sharerMethod: SharerMethod.Window,
    url: 'www.google.gt',
    prop: {
        facebook: {
            text: 'Share'
        },
        twitter: {
            text: 'Tweet'
        },
    }
};

@NgModule({
    declarations: [
        RentaComponent,
        ShareComponent,
        ConfirmComponent,
        DemoAccountComponent,
        LoginComponent,
        PartnerComponent,
        PubComponent,
        InvestPreneurComponent,
        DpeComponent,
        GesComponent,
        TutoComponent,
        AccountComponent,
        FormComponent,
        NewsComponent,
        RateComponent,
        CalendlyComponent,
        LeducationFinanciereComponent,
        PolygoneComponent,
        LoginFormComponent,
        UpgradePlanV2Component,
        ToomanyFavComponent,
        PurpleComponent,
        IncreaseTrialComponent,
        ShowPromoComponent,
        EditCaracComponent,
        EditAnnexeComponent,
        EditOtherCaracComponent,
        EditDiagComponent,
        EditDescriptionComponent,
        PhoneComponent,
        VideoComponent,
        QlowerComponent,
        EndtrialComponent,
        ConfirEndtrialComponent,
        ChurnComponent,
    ],
    exports: [
        GesComponent,
        DpeComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatSliderModule,
        RouterModule.forChild(UserRoutes),
        FormsModule,
        MatDialogModule,
        ShareButtonsModule.withConfig(customConfig),
        ShareIconsModule,
        MessagesModule,
        PipeModule,
        ReactiveFormsModule,
        AlertModule,
        MatProgressSpinnerModule,
        StarRatingModule.forRoot(),
        MatTooltipModule,
        DirectiveModule,
        Nl2BrPipeModule,
    ]
})
export class PopupModule {
}
